import { logUsage } from 'owa-analytics';
import getExtraCustomDataForDatapoint from './getExtraCustomDataForDatapoint';

export default function logCloseDatapoint(
    closingSource: string,
    sessionLength: number,
    sessionPreviewCount: number
) {
    const commonData = getExtraCustomDataForDatapoint();
    logUsage(
        'SxSClose',
        { ...commonData.customData, closingSource },
        {
            cosmosOnlyData: JSON.stringify({
                ...commonData.cosmosOnlyData,
                sessionLength,
                sessionPreviewCount,
            }),
        }
    );
}
